import ListService from "@/services/ListService";

export const namespaced = true;

export const state = {
  sections: [],
  platoons: [],
  roles: [],
  workoutTypes: [],
  profileList: [],
};

export const mutations = {
  setSections(state, sections) {
    state.sections = sections;
  },
  setPlatoons(state, platoons) {
    state.platoons = platoons;
  },
  setRoles(state, roles) {
    state.roles = roles;
  },
  setWorkoutTypes(state, workoutTypes) {
    state.workoutTypes = workoutTypes;
  },
  setProfileList(state, profileList) {
    state.profileList = profileList;
  },
};

export const actions = {
  getSections({ commit, dispatch }, { sort, order }) {
    return ListService.sections({ sort, order })
      .then((res) => {
        commit("setSections", res.data);
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  getPlatoons({ commit, dispatch }, { sort, order, platoon_id }) {
    return ListService.platoons({ sort, order, platoon_id })
      .then((res) => {
        commit("setPlatoons", res.data);
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  getRoles({ commit, dispatch }, { sort, order }) {
    return ListService.roles({ sort, order })
      .then((res) => {
        commit("setRoles", res.data);
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  getWorkoutTypes({ commit, dispatch }, { sort, order, is_active }) {
    return ListService.workoutTypes({ sort, order, is_active })
      .then((res) => {
        commit("setWorkoutTypes", res.data);
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
  getProfileList({ commit, dispatch }, { sort, order, is_active, is_top }) {
    return ListService.profileList({ sort, order, is_active, is_top })
      .then((res) => {
        commit("setProfileList", res.data);
        return res.data;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
};

export const getters = {
  getSectionName: (state) => (section_id) => {
    if (section_id == -1) return { section_id: -1, name: "All Sections" };

    return state.sections.data.find((s) => s.section_id == section_id);
  },
  getWorkoutTypeName: (state) => (workout_type_id) => {
    let obj = state.workoutTypes.data.find(
      (s) => s.workout_type_id == workout_type_id
    );
    return obj ? obj.workout_name : "";
  },
  getPlatoonName: (state) => (platoon_id) => {
    if (platoon_id == -1) return { platoon_id: -1, name: "All Platoons" };
    if (!state.platoons || !state.platoons.data) return { platoon_id: -1, name: "All Platoons" };

    return state.platoons.data.find((s) => s.platoon_id == platoon_id);
  },
};
